<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
// AuditView of the admin console — template converted mechanically from design admin-taskcoolV1
// (design/tools/convert_admin_v1.py); values come from renderVals.ts.
import { s, hv } from '../tpl';
defineProps<{ g: any }>();
</script>

<template>
<div :style="s('display:flex; flex-direction:column; gap:14px; animation:apView 220ms ease-out;')">
  <div :style="s('display:flex; align-items:center; gap:10px; flex-wrap:wrap;')">
    <div :style="s('display:flex; flex-wrap:wrap; gap:2px;')">
      <template v-for="(f, f$i) in g.auditFilters" :key="f$i">
        <button @click="f.onClick" :style="s(`height:30px; padding:0 12px; border:none; border-radius:999px; font-family:inherit; font-size:13px; font-weight:700; cursor:pointer; background:${f.bg}; color:${f.color};`)">{{ f.label }}</button>
      </template>
    </div>
    <div :style="s('flex:1;')"></div>
    <button @click="g.exportLog" :style="s('height:30px; padding:0 14px; border:none; border-radius:999px; background:#2a2b2f; color:#e7e7ea; font-family:inherit; font-size:13px; cursor:pointer;')">خروجی CSV</button>
  </div>
  <div :style="s('border-radius:12px; background:#26272b;')">
    <template v-for="(a, a$i) in g.auditRows" :key="a$i">
      <div :style="s(`display:flex; align-items:center; gap:12px; padding:${g.rowPad} 16px; border-bottom:1px solid #2a2b2f; font-size:14px; flex-wrap:wrap;`)">
        <div :style="s(`flex:0 0 28px; width:28px; height:28px; border-radius:50%; background:${a.av}; color:#fff; font-size:11px; font-weight:700; display:grid; place-items:center;`)">{{ a.initial }}</div>
        <div :style="s('flex:1; min-width:240px; color:#c9cacf;')"><b :style="s('color:#e7e7ea; font-weight:500;')">{{ a.actor }}</b> {{ a.action }} <span dir="auto" :style="s('color:#e7e7ea;')">{{ a.target }}</span></div>
        <span :style="s(`font-size:11px; font-weight:700; padding:2px 9px; border-radius:999px; background:#34353a; color:${a.tagColor};`)">{{ a.tagLabel }}</span>
        <span :style="s('flex:0 0 120px; width:120px; font-family:\'JetBrains Mono\',monospace; font-size:12px; color:#76777d; direction:ltr; text-align:left;')">{{ a.ip }}</span>
        <span :style="s('flex:0 0 96px; width:96px; font-size:12px; color:#8a8b91; text-align:left;')">{{ a.time }}</span>
      </div>
    </template>
  </div>
</div>
</template>
